import React from 'react'
import PropTypes from 'prop-types'

import { Control as InputControl } from 'commons/js/ui/Input'
import { Input } from '@elparking/components'

import CardInput from './CardInput'

const FieldInput = (props) => <Input {...props} inputComponent={CardInput} />

class CardField extends React.Component {
    static propTypes = {
        model: PropTypes.string,
        cardElement: PropTypes.func,
    }

    render () {
        const { model, cardElement, ...restProps } = this.props

        return (
            <InputControl
              {...restProps}
              model={model}
              component={FieldInput}
              cardElement={cardElement}
              validateOn='blur'
              showClearButton={false}
            />
        )
    }
}

export default CardField
